<template>
  <div>
    <!-- header title -->
    <div v-if="headTitle" class="font-weight-bold mb-1 header__title">
      {{ headTitle }}
    </div>

    <!-- description -->
    <div class="font-weight-normal mb-1 text__title" :class="classDescription">
      {{ title }}
    </div>

    <!-- description -->
    <div class="font-weight-normal mb-1 text__description" :class="classDescription">
      {{ description }}
    </div>

    <!-- criterion : In case show info -->
    <div v-if="pass === null && !isReview">
      <!-- pass -->
      <div class="d-flex flex-row container__criteria-pass">
        <div class="flex-shrink-0 font-weight-bold text__criteria-title ml-3">Pass</div>
        <div class="flex-shrink-0 criterion__dash">—</div>
        <div v-safe-html="passCriterion" class="text__criteria-description text-pre-wrap" />
      </div>
      <!-- not yet -->
      <div class="d-flex flex-row container__criteria-not-yet">
        <div class="flex-shrink-0 font-weight-bold text__criteria-title ml-3">Not yet</div>
        <div class="flex-shrink-0 criterion__dash">—</div>
        <div v-safe-html="notYetCriterion" class="text__criteria-description text-pre-wrap" />
      </div>
    </div>

    <!-- criterion : In case evaluated -->
    <div v-if="pass !== null && !isReview">
      <!-- pass -->
      <div class="d-flex flex-row container__criteria-pass mt-4">
        <div>
          <font-awesome-icon
            icon="check-circle"
            class="font-size-lg btn__icon mr-3"
            :class="classPass"
          />
        </div>
        <div class="font-weight-normal h5" :class="classPass">Pass</div>
      </div>
      <!-- not yet -->
      <div class="d-flex flex-row container__criteria-not-yet mt-3">
        <div>
          <font-awesome-icon
            icon="times-circle"
            class="font-size-lg btn__icon mr-3"
            :class="classNotYet"
          />
        </div>
        <div class="font-weight-normal h5" :class="classNotYet">Not yet</div>
      </div>
    </div>

    <!-- Review -->
    <b-form-radio-group v-if="isReview" class="mt-3">
      <div class="d-flex flex-row container__criteria-pass mb-3">
        <b-form-radio
          :id="`pass-criterion-radio-${index}`"
          v-model="isSelectedPass"
          :class="`my-1 pass-criterion-radio-${index}`"
          :name="`pass-criterion-radio-${index}`"
          :value="true"
          @change="onSelectedRadio"
        >
          <div class="font-weight-bold h5">Pass</div>
          <div
            v-safe-html="passCriterion"
            class="text__criteria-description text-pre-wrap text-dark mt-2"
          />
        </b-form-radio>
      </div>
      <div class="d-flex flex-row container__criteria-not-yet">
        <b-form-radio
          :id="`not-yet-criterion-radio-${index}`"
          v-model="isSelectedPass"
          :class="`my-1 not-yet-criterion-radio-${index}`"
          :name="`not-yet-criterion-radio-${index}`"
          :value="false"
          @change="onSelectedRadio"
        >
          <div class="font-weight-bold h5">Not yet</div>
          <div
            v-safe-html="notYetCriterion"
            class="text__criteria-description text-pre-wrap text-dark mt-2"
          />
        </b-form-radio>
      </div>
    </b-form-radio-group>

    <!-- Passed or Feedback -->
    <!-- <div v-if="!isReview" class="mt-3">
      <div class="d-flex flex-row container__criteria-pass">
        <div
          class="my-2 font-weight-normal h5"
          :class="{ 'text-success': pass }"
        >
          <font-awesome-icon
            :icon="{ prefix: 'fas', iconName: 'check-circle' }"
            class="font-size-sm mr-2"
          />
          Pass
        </div>
      </div>
      <div class="d-flex flex-row container__criteria-not-yet">
        <div
          class="my-2 font-weight-normal h5"
          :class="{ 'text-danger': !pass }"
        >
          <font-awesome-icon
            :icon="{ prefix: 'fas', iconName: 'times-circle' }"
            class="font-size-sm mr-2"
          />
          Not yet
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
/**
 * Show criterion both learning outcome & addtional criterion
 * there have 2 type : show info & evaluated
 * if evaluated need to pass props "pass"
 *
 * example: @/examples/ShowCriterion.vue
 */

export default {
  name: 'BaseLearningOutcomeAndCriterion',

  props: {
    index: {
      type: [Number, String],
      default: null
    },
    id: {
      type: Number,
      default: null
    },
    learningOutcome: {
      type: Object,
      default: () => ({})
    },
    additionalCriterion: {
      type: Object,
      default: () => ({})
    },
    headTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: '',
      require: true
    },
    description: {
      type: String,
      default: '',
      require: true
    },
    passCriterion: {
      type: String,
      default: '',
      require: true
    },
    notYetCriterion: {
      type: String,
      default: '',
      require: true
    },
    pass: {
      type: Boolean,
      default: null
    },
    isReview: {
      type: Boolean,
      default: false
    },
    showTitle: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isSelectedPass: ''
    };
  },

  computed: {
    classPass() {
      return this.pass ? 'text-success' : 'text-muted';
    },
    classNotYet() {
      return !this.pass ? 'text-danger' : 'text-muted';
    },
    classDescription() {
      return this.pass !== null ? 'mt-3' : '';
    }
  },

  methods: {
    onSelectedRadio() {
      // if (this.learningOutcome) {
      //   this.$set(this.learningOutcome, "isSelectedPass", this.isSelectedPass);
      // }
      // if (this.additionalCriterion) {
      //   this.$set(
      //     this.additionalCriterion,
      //     "isSelectedPass",
      //     this.isSelectedPass
      //   );
      // }
      this.$emit('onSelectedRadio', this.additionalCriterion, this.isSelectedPass);
    }
  }
};
</script>

<style lang="scss" scoped>
.text__criteria-title {
  color: #7a7b97;
  width: 60px;
}

.criterion__dash {
  color: #7a7b97;
  width: 24px;
}

// https://stackoverflow.com/questions/36150458/flex-item-overflows-container-due-to-long-word-even-after-using-word-wrap/36150638
.text__criteria-description {
  color: #7a7b97;
  min-width: 50%;
}
</style>
